import React from "react";

export default function AgendaIconPurple() {
  return (
    <svg
      className="agenda-link-icon"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_663_4005)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1635 1C12.6219 1 12.9935 1.3716 12.9935 1.83V6H17.1635C17.6219 6 17.9935 6.3716 17.9935 6.83C17.9935 7.2884 17.6219 7.66 17.1635 7.66H12.1635C11.7051 7.66 11.3335 7.2884 11.3335 6.83V1.83C11.3335 1.3716 11.7051 1 12.1635 1Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.74609 9.99672C6.74609 9.76614 6.93301 9.57922 7.16359 9.57922H13.8303C14.0608 9.57922 14.2478 9.76614 14.2478 9.99672C14.2478 10.2273 14.0608 10.4142 13.8303 10.4142H7.16359C6.93301 10.4142 6.74609 10.2273 6.74609 9.99672Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.74609 6.66335C6.74609 6.43277 6.93301 6.24585 7.16359 6.24585H8.83026C9.06084 6.24585 9.24776 6.43277 9.24776 6.66335C9.24776 6.89393 9.06084 7.08085 8.83026 7.08085H7.16359C6.93301 7.08085 6.74609 6.89393 6.74609 6.66335Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.746 13.33C6.746 13.0994 6.93292 12.9125 7.1635 12.9125H13.5117H13.8302C14.0607 12.9125 14.2477 13.0994 14.2477 13.33C14.2477 13.5606 14.0607 13.7475 13.8302 13.7475H12.7758H7.1635C6.93292 13.7475 6.746 13.5606 6.746 13.33Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.49667 1C4.83451 1 4.19947 1.26304 3.73126 1.73126C3.26304 2.19947 3 2.83451 3 3.49667V16.83C3 17.4922 3.26304 18.1272 3.73126 18.5954C4.19947 19.0636 4.83451 19.3267 5.49667 19.3267H12.0848C11.8765 18.8062 11.7412 18.2486 11.6914 17.6667H5.49667C5.27477 17.6667 5.06196 17.5785 4.90505 17.4216C4.74815 17.2647 4.66 17.0519 4.66 16.83V3.49667C4.66 3.27477 4.74815 3.06196 4.90505 2.90505C5.06196 2.74815 5.27477 2.66 5.49667 2.66H11.8195L16.3333 7.1738V11.4529C16.7092 11.3767 17.0983 11.3367 17.4967 11.3367C17.664 11.3367 17.8296 11.3438 17.9933 11.3576V6.83C17.9933 6.60987 17.9059 6.39876 17.7502 6.2431L12.7502 1.2431C12.5946 1.08745 12.3835 1 12.1633 1H5.49667ZM13.8302 13.7475H12.7758C12.9942 13.4461 13.2408 13.1665 13.5117 12.9125H13.8302C14.0607 12.9125 14.2477 13.0994 14.2477 13.33C14.2477 13.5606 14.0607 13.7475 13.8302 13.7475Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.4968 13.4142C15.4262 13.4142 13.7476 15.0928 13.7476 17.1634C13.7476 19.234 15.4262 20.9126 17.4968 20.9126C19.5674 20.9126 21.2459 19.234 21.2459 17.1634C21.2459 15.0928 19.5674 13.4142 17.4968 13.4142ZM12.9126 17.1634C12.9126 14.6316 14.965 12.5792 17.4968 12.5792C20.0285 12.5792 22.0809 14.6316 22.0809 17.1634C22.0809 19.6952 20.0285 21.7476 17.4968 21.7476C14.965 21.7476 12.9126 19.6952 12.9126 17.1634Z"
          fill="#644AD4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.4968 14.2458C17.7274 14.2458 17.9143 14.4328 17.9143 14.6633V16.9053L19.3502 17.6233C19.5565 17.7264 19.6401 17.9772 19.5369 18.1834C19.4338 18.3896 19.183 18.4732 18.9768 18.3701L17.3101 17.5368C17.1687 17.4661 17.0793 17.3215 17.0793 17.1634V14.6633C17.0793 14.4328 17.2663 14.2458 17.4968 14.2458Z"
          fill="#644AD4"
        />
      </g>
      <defs>
        <clipPath id="clip0_663_4005" className="agenda-link-icon">
          <rect width="22" height="22" fill="#644AD4" />
        </clipPath>
      </defs>
    </svg>
  );
}
